var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogaut({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.375 19.5312C9.375 19.9627 9.72478 20.3125 10.1563 20.3125L22.6562 20.3125C23.0877 20.3125 23.4375 19.9627 23.4375 19.5312L23.4375 5.46875C23.4375 5.03728 23.0877 4.6875 22.6562 4.6875L10.1562 4.6875C9.72478 4.6875 9.375 5.03728 9.375 5.46875L9.375 8.59375C9.375 9.02522 9.02522 9.375 8.59375 9.375C8.16228 9.375 7.8125 9.02522 7.8125 8.59375L7.8125 5.46875C7.8125 4.17433 8.86183 3.125 10.1562 3.125L22.6562 3.125C23.9507 3.125 25 4.17433 25 5.46875L25 19.5312C25 20.8257 23.9507 21.875 22.6562 21.875L10.1563 21.875C8.86183 21.875 7.8125 20.8257 7.8125 19.5312L7.8125 16.4062C7.8125 15.9748 8.16228 15.625 8.59375 15.625C9.02522 15.625 9.375 15.9748 9.375 16.4062L9.375 19.5312Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.228823 13.0524C-0.0762745 12.7473 -0.0762745 12.2527 0.228823 11.9476L4.91632 7.26007C5.22142 6.95498 5.71608 6.95498 6.02118 7.26007C6.32627 7.56517 6.32627 8.05983 6.02118 8.36493L2.66735 11.7188L16.4062 11.7187C16.8377 11.7187 17.1875 12.0685 17.1875 12.5C17.1875 12.9315 16.8377 13.2812 16.4062 13.2812L2.66735 13.2813L6.02118 16.6351C6.32627 16.9402 6.32627 17.4348 6.02118 17.7399C5.71608 18.045 5.22142 18.045 4.91632 17.7399L0.228823 13.0524Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogaut);
export default __webpack_public_path__ + "static/media/logaut.4f5543f4eddd26979d1281b3f9d67799.svg";
export { ForwardRef as ReactComponent };